import dayjs from 'dayjs';

import { UserDto } from '@/apis/admin-api/types';

import { DATES, TERMS_DISMISSAL_KEY } from './constants';

export const isUserCreatedBeforeJuly1stCutoff = (userCreatedAt: string): boolean => {
  return dayjs(userCreatedAt).isBefore(dayjs(DATES.JULY_FIRST_2025_17_UTC));
};

export const isBeforeJuly31stCutoff = (): boolean => {
  return dayjs().isBefore(dayjs(DATES.JULY_31ST_2025_17_UTC));
};

export const wasDismissedToday = (): boolean => {
  const dismissedDate = localStorage.getItem(TERMS_DISMISSAL_KEY);
  if (!dismissedDate) return false;

  const dismissedDay = dayjs(dismissedDate);
  const now = dayjs();

  return dismissedDay.isSame(now, 'day');
};

export const storeDismissalDate = (): void => {
  localStorage.setItem(TERMS_DISMISSAL_KEY, dayjs().format('YYYY-MM-DD'));
};

export const shouldShowTermsPopup = (user: UserDto): boolean => {
  // If terms have been accepted, don't show popup
  if (user.termsAndConditionsAcceptedAt) {
    return false;
  }

  // If user was created before July 1st, 2025 - 17:00:00 PM UTC, check if dismissed today
  if (user.createdAt && isUserCreatedBeforeJuly1stCutoff(user.createdAt)) {
    return !wasDismissedToday();
  }

  // User was created after July 1st, 2025 - 17:00:00 PM UTC, must accept immediately
  return true;
};

// Popup-specific utilities
export const isExistingUser = (userCreatedAt?: string): boolean => {
  if (!userCreatedAt) return false;
  return isUserCreatedBeforeJuly1stCutoff(userCreatedAt);
};

export const canUserDismissPopup = (userCreatedAt?: string): boolean => {
  if (!userCreatedAt) return false;
  return isUserCreatedBeforeJuly1stCutoff(userCreatedAt) && isBeforeJuly31stCutoff();
};
